<div
	class="cbta-avatar"
	[class.border]="hasBorder"
	[class.border-red]="hasBorder"
	[class.rounded-full]="radius === 'full'"
	[class.rounded-md]="radius === 'md'"
	[class.rounded-lg]="radius === 'lg'"
	[class.rounded-xl]="radius === 'xl'"
	[class.radius-0]="radius === 'none'"
	[ngStyle]="{ 'width.px': size, 'height.px': size }"
>
	<!-- todo: put profile image -->
	@if (!hasImage) {
		<div>
			<span [ngStyle]="{ 'font-size.px': size * 0.4 }" class="text-black">
				{{ initial }}
			</span>
		</div>
	}
	@if (hasImage) {
		<div>
			<img [src]="imageUrl" alt="Avatar image." [width]="size" [height]="size" (error)="onImageError()" />
		</div>
	}
</div>
